export function parseStringResponse(response: any): string | undefined {
    if (response === null || typeof response === "undefined") return undefined;

    if (typeof response !== "string") {
        console.log("Response item is not a string");
        return undefined;
    }

    if (response.length === 0) return undefined;

    return response;
}

export function parseNumberResponse(response: any): number | undefined {
    if (response === null || typeof response === "undefined") return undefined;

    const _response = +response;

    if (isNaN(_response)) {
        console.log("Response item is not a number");
        return undefined;
    }

    return _response;
}

export function parseArrayResponse(response: any): any[] | undefined {
    if (response === null || typeof response === "undefined") return undefined;

    if (!Array.isArray(response)) {
        console.log("Response item is not an array");
        return undefined;
    }

    return response;
}

export function parseDateResponse(response: any): Date | undefined {
    if (response === null || typeof response === "undefined") return undefined;

    const date = new Date(response);

    return isValidDate(date) ? date : undefined;
}

function isValidDate(d: any) {
    return d instanceof Date && !isNaN(+d);
}

export function allAreUndefined(...testItems: any[]) {
    for (let i = 0; i < testItems.length; i++) {
        const item = testItems[i];

        if (typeof item !== "undefined") return false;
    }

    return true;
}
